export default class EvtItemMoved {
    constructor(
        // eslint-disable-line no-useless-constructor
        public itemId: number,
        public fromSectionId: number | null,
        public toSectionId: number | null,
        public newIndex: number
    ) {}
}
